enum SectionContentDisplay {
    STACKED = 'Stacked',
    FLEX = 'Flex',
    ONE_THIRD = '1/3',
    ONE_HALF = '1/2',
    ONE_THIRD_TWO_THIRD = '1/3-2/3'
}

export default SectionContentDisplay;